module.exports = __webpack_public_path__ + "img/edit.b43f2209.svg";